import { render, staticRenderFns } from "./SubmitForm8.vue?vue&type=template&id=712a45d6&scoped=true"
import script from "./SubmitForm8.vue?vue&type=script&lang=ts"
export * from "./SubmitForm8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a45d6",
  null
  
)

export default component.exports